import styled from 'styled-components';

export const SideTitle = styled.div`
  padding-bottom: 6px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  margin-bottom: ${({ extraMargin }) => (extraMargin ? '18px' : '12px')};
  font-weight: 600;

  &:first-letter {
    text-transform: uppercase;
  }
`;
